import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { Cms } from '../cms/models/cms.model';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CmsStudioService } from '../cms/cms-studio.service';
import { CmsViewDirectiveService } from '../cms/cmsdirectives/cmsviewdirective.service';
import { CmsViewDirectiveComponent } from '../cms/cmsdirectives/cmsviewdirective.component';
import { CurrentUserModel } from '../models/account-ledger.model';
import { AuthService } from '../services/auth.service';
import { NgProgressService } from '../services/ngProgress.service';

@Component({
  selector: 'app-kbtemplate',
  templateUrl: './kbtemplate.component.html',
  styleUrls: ['./kb.component.css'],
  providers: [CmsViewDirectiveComponent]
})

export class KbTemplateComponent implements OnInit {
  title = 'Knowledge Base';
  component: any;
  setFullWindow = false;
  subWidth: string;
  cms: Cms;
  viewChildId = null;
  currentPage: string = '';

  viewNavIndex: number;
  currentUserModel: CurrentUserModel;

  constructor(private router: Router, public ngProgress: NgProgressService, private activeRouter: ActivatedRoute,
    private cmsStudioService: CmsStudioService, private authService: AuthService, @Inject(CmsViewDirectiveService) private service,
    @Inject(ViewContainerRef) private viewContainerRef) { }

  ngOnInit() {
    this.ngProgress.start();
    this.activeRouter.params.subscribe(params => {
      var page = params["page"];
      this.currentPage = page;
      if (params["id"]) {
        this.getCmsById(params["id"]);
      }
      else if(page && page.length > 0){
        if(page == 'faq') {
          this.getCmsById("5d4227488900fb11686c68b9");
        }
        else if(page == 'apidocumentation'){
          this.getCmsById("5ca1bf1214d1f917d4c9176b");
        }
      }
      else {
        this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
          this.currentUserModel = res;
        this.getCmsHomePage();
        });
      }
    })
  }

  getCmsById(id) {
    this.cmsStudioService.getCmsById(id)
      .subscribe(res => {
        //console.log(res);
        this.cms = res.count;
        this.ngProgress.done();
      })
  }

  getCmsHomePage() {
    this.cmsStudioService.getCmsHomePage(this.currentUserModel.companyCode)
      .subscribe(res => {
        if (res && res.stat == "success") {
          this.cms = res.cms;
        }
        this.ngProgress.done();
      })
  }

  clickEvent(e) {
    //console.log(e.target.dataset.id);
    if (e.target.dataset.class == 'cmsTemplate' && this.viewChildId != e.target.dataset.id) {
      jQuery("app-cms-view-directive").hide();
      this.service.setRootViewContainerRef(this.viewContainerRef);
      this.service.addDynamicComponent(e.target.dataset.id);
      //this.viewChildId = e.target.dataset.id;
      $('.page-contents').animate({ scrollLeft: $('app-kbtemplate').width() }, 400);
    }
  }

  getBackgroundColor(i) {
    var ret = '#FBFBFB';
    switch (i) {
      case 0:
        ret = '#FBFBFB';
        break;
      case 1:
        ret = '#F7F7F7';
        break;
      case 2:
        ret = '#F4F4F4';
        break;
      case 3:
        ret = '#EEEEEE';
        break;
    }
    return ret;
  }

  viewNavigation(i) {
    this.viewNavIndex = i
    $('.page-contents').animate({ scrollLeft: $('#viewCmsStuiod').width() }, 400);
  }

  openViewStudio() {
    $('.page-contents').animate({ scrollLeft: -$('#cmsView').width() }, 400);
    jQuery("app-cms-view-directive").hide();
  }

  close() {
    if (this.currentPage == 'apidocumentation') {
      this.router.navigateByUrl('/myAccount');
    } else {
      this.router.navigateByUrl('/home');
    }
    
  }
}
